import axios from '../index'
export default {
    getInstitucion () {
        return axios.get('/instituciones/usuario/')
    },
    getCiclosEscolares (institucionId) {
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/'+ institucionId)
    },
    //OFERTAS ACADEMICAS
    getOfertaAcademicaTable(params){
        return axios.get('/ofertas/paginate',{params})
    },
    getPeriodoOferta(programa){
        return axios.get('/ofertas/atributos/' + programa)
    },
    getTurnosOferta(){
        return axios.get('/ofertas/turnos')
    },
    postOfertaNuevoIngresoCrear(formData){
        return axios.post('/ofertas/store', formData)
    },
    postOfertaNuevoIngresoEditar(idRegistro,formData){
        return axios.post('/ofertas/update/' + idRegistro, formData)
    },
    postEliminarOfertaNuevo(idRegistro, formData){
        return axios.post('/ofertas/delete/' + idRegistro, formData)
    },
    //PROSPECTOS
    getOfertaAcademica(institucion, cicloEscolar){
        return axios.get('/ofertas/filtrar/' + institucion + '/' + cicloEscolar)
    },
    getGrupo(institucion, params){
        return axios.get('/grupos-administrativos/gruposInstitucion/' + institucion, {params})
    },
    getEstatusAlumno(params){
        return axios.get('/api/status',{params})
    },
    getProspectosTotal(params){
        return axios.get('/dashboard/prospectos_total', {params})
    },
    getProspectosInteresados(params){
        return axios.get('/dashboard/prospectos_interesados', {params})
    },
    getProspectosInscriptos(params){
        return axios.get('/dashboard/prospectos_inscritos', {params})
    },
    getProspectos(params){
        return axios.get('/prospectos/paginate', {params})
    },
    getProgramaProspecto(institucionId) {
        return axios.get('/programas/institucion/'+ institucionId)
    },
    getOfertaPrograma(programa, ciclo) {
        return axios.get('/ofertas/programa/'+ programa + '/' + ciclo)
    },
    postProspectosCrear(payload) {
        return axios.post('/prospectos/store', payload)
    },
    postProspectosEditar(id, formData) {
        return axios.post('/prospectos/update/' + id, formData)
    },
    getEscuelasProcedencia(params){
        return axios.get('/getEscuelas', {params})
    }, 
    // REGISTRO DE ASPIRANTES (LANDING)
    getNivelAcademicoAspirante(params){
        return axios.get('/registro-prospecto/getNivelAcademico', {params})
    },
    getEscuelaInteresAspirante(nivel_id, params){
        return axios.get('/registro-prospecto/institucionesGroupByEstados/' + nivel_id, {params})
    },
    getCiclosEscolaresAspitante(institucion_id){
        return axios.get('/registro-prospecto/ciclosPorInstitucion/' + institucion_id)
    },
    getOfertaAcademicasAspirante(params){
        return axios.get('/registro-prospecto/ofertasAcademicas', {params})
    },
    postGuardarAspirantes(payload){
        return axios.post('/registro-prospecto/guardarProspecto', payload)
    },
    getRechaptcha(){
        return axios.get('/registro-prospecto/generateString')
    }
}